// extracted by mini-css-extract-plugin
export default {"main":"Main_main__bSred","grid":"Main_grid__4Sa-J"};